<template>
<div :class="className">
  <TheHeaderTopbarButton
    icon-left="user"
    icon-right="chevron-down"
    :text="welcome"
    @click.native="handleClick" />
  <div v-show="isActive" class="header-topbar-profile__level">
    <ul>
      <li @click="handleClick"><router-link :to="manage.route" >{{ manage.text }}</router-link></li>
      <li><a href="#" @click.prevent.stop="handleLogout">{{ logout.text }}</a></li>
      <li v-if="admin"><a :href="admin.url" >{{ admin.text }}</a></li>
    </ul>
  </div>
</div>
</template>

<script>
import TheHeaderTopbarButton from './TheHeaderTopbarButton'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TheHeaderTopbarProfile',
  data () {
    return {
      isActive: false
    }
  },
  components: {
    TheHeaderTopbarButton
  },
  computed: {
    ...mapGetters({
      profile: 'header/getProfile'
    }),
    className () {
      return 'header-topbar-profile'
    },
    welcome () {
      return this.profile.text
    },
    admin () {
      return this.profile.admin
    },
    manage () {
      return this.profile.manage
    },
    logout () {
      return this.profile.logout
    }
  },
  methods: {
    ...mapActions({
      requestLogout: 'auth/requestLogout'
    }),
    handleClick () {
      this.isActive = !this.isActive
    },
    handleLogout () {
      this.requestLogout()
    }
  }
}
</script>

<style lang="scss">
.header-topbar-profile{
  position: relative;

  // Level

  &__level{
    @include media("large"){
      position: absolute;
      left: 0;
    }

    width: 100%;
    z-index: 1;
    background-color: colors("topbar");
    border-bottom: 1px solid shade(colors("topbar"), 20%);

    ul{
      @include no-type-list;

      a{
        @include text-color(white, colors("primary"));
        @include icon(icons("chevron-right"));
        @include media("small-medium"){
          padding: layout("spacing");
          &:not(:last-of-type){
            border-bottom: 1px solid shade(colors("foreground"), 20%);
          }
        }
        @include media("large"){
          padding: layout("spacing")*0.7;
        }

        padding: layout("spacing")/2 layout("spacing");
        display: block;
        font-size: 1.4rem;
        width: 100%;
        font-weight: font-weights("medium");
        line-height: 1;

        &::before{
          font-size: 1.2rem;
          margin-right: layout("spacing")/4;
        }
      }
    }
  }

  // icon right
  .icon-right{
    @include media("small-medium"){
      margin-left: auto;
    }
  }
}
</style>
